document.addEventListener('DOMContentLoaded', () => {
  const body = document.body

  const isTestEnv = window.location.hostname.includes('stg-spc.net') || window.location.hostname.includes('test.net')
  const basePath = isTestEnv ? '/projects/JWD' : ''
  const baseUrl = window.location.origin + basePath

  if (body.classList.contains('single-news')) {
    const yearFilter = document.getElementById('news-year-filter')
    if (yearFilter) {
      yearFilter.addEventListener('change', () => {
        const selectedYear = yearFilter.value
        if (selectedYear) {
          window.location.href = `${baseUrl}/news/${selectedYear}/`
        }
      })
    }

    // カテゴリでフィルタリング
    const categoryLinks = document.querySelectorAll('.js-layerMenu__link')
    categoryLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        const categorySlug = link.getAttribute('data-category')
        const url = new URL(`${baseUrl}/news/`)
        if (categorySlug !== 'all') {
          url.searchParams.set('category', categorySlug)
        }
        window.location.href = url.toString()
      })
    })
  }

  if (!body.classList.contains('post-type-archive-news')) {
    return
  }

  const yearFilter = document.getElementById('news-year-filter')
  const categoryLinks = document.querySelectorAll('.js-layerMenu__link')

  let currentUrl = new URL(window.location.href)
  let pathSegments = window.location.pathname.replace(basePath, '').split('/').filter(Boolean)
  let yearFromUrl = pathSegments.length > 1 && /^\d{4}$/.test(pathSegments[1]) ? pathSegments[1] : ''

  if (yearFilter) {
    if (yearFromUrl) {
      yearFilter.value = yearFromUrl
    } else {
      yearFilter.value = ''
    }

    yearFilter.addEventListener('change', () => {
      let selectedYear = yearFilter.value
      let newPath = selectedYear ? `${baseUrl}/news/${selectedYear}/` : `${baseUrl}/news/`
      let newUrl = new URL(newPath, window.location.origin)
      let currentCategory = currentUrl.searchParams.get('category')
      if (currentCategory) {
        newUrl.searchParams.set('category', currentCategory)
      }
      window.location.href = newUrl.toString()
    })
  }

  if (categoryLinks.length > 0) {
    let activeCategory = currentUrl.searchParams.get('category') || 'all'
    categoryLinks.forEach((link) => {
      if (link.getAttribute('data-category') === activeCategory) {
        link.classList.add('is_active')
      } else {
        link.classList.remove('is_active')
      }

      link.addEventListener('click', (e) => {
        e.preventDefault()
        let categorySlug = link.getAttribute('data-category')
        let selectedYear = yearFilter.value || yearFromUrl
        let newPath = selectedYear ? `${baseUrl}/news/${selectedYear}/` : `${baseUrl}/news/`
        let newUrl = new URL(newPath, window.location.origin)
        if (categorySlug === 'all') {
          newUrl.searchParams.delete('category')
        } else {
          newUrl.searchParams.set('category', categorySlug)
        }
        window.location.href = newUrl.toString()
      })
    })
  }
})
